import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

/**
 * Append an audit row to `ticketLogs` (company-scoped company activity stream).
 * Used for tickets, labels, links, team changes, and other org events.
 * `participantUids` controls visibility for non–elevated roles (array-contains query).
 */
export async function appendTicketLog(db, {
  companyId,
  ticketId,
  action,
  summary,
  meta,
  actorUid,
  actorEmail,
  actorRole,
  participantUids,
  resourceType,
}) {
  const tenantId = typeof companyId === 'string' ? companyId.trim() : '';
  if (!tenantId) {
    throw new Error('appendTicketLog requires companyId for tenant isolation.');
  }
  const uids = [...new Set((participantUids || []).filter(Boolean))];
  await addDoc(collection(db, 'ticketLogs'), {
    companyId: tenantId,
    ticketId: ticketId || null,
    action,
    summary: summary || action,
    meta: meta || null,
    actorUid: actorUid || null,
    actorEmail: actorEmail || '',
    actorRole: actorRole || '',
    participantUids: uids,
    resourceType: resourceType || (ticketId ? 'ticket' : 'general'),
    createdAt: serverTimestamp(),
  });
}

export function participantsForTicket(ticket, actorUid) {
  const u = new Set();
  if (ticket?.reporterUid) u.add(ticket.reporterUid);
  if (ticket?.assigneeUid) u.add(ticket.assigneeUid);
  if (actorUid) u.add(actorUid);
  return [...u];
}
